import { gql } from '@/utilities/gql';
import { VALUATION_FRAGMENT } from '../valuationFragment';
import { NARRATIVE_OWNER_FRAGMENT } from '@/components/NarrativeAuthor';

export const NARRATIVE_FRAGMENT = gql(
  `
  fragment NarrativeFields on Narrative @_unmask {
    excerpt
    isDiscoverable
    companyId
    primaryCount
    draftUpdate {
      contentHtml
      title
      valuation {
        ...ValuationFields
      }
    }
    latestPublishedUpdate {
      coreHtml
    }
    earliestPublishedUpdate {
      willLockAt
    }
    isSponsored
    contentBlocks {
      title
      id
      contentHtml
    }
    id
    slug
    title
    isPrimary
    valuation {
      ...ValuationFields
    }
    voteCount {
      upvotes
    }
    userHoldsPosition
    coverImageUrl
    createdAt
    updatedAt
    type
    owner {
      ...NarrativeOwnerFields
    }
    company {
      uniqueSymbolSlug
      country {
        iso2
      }
      primaryIndustry {
        slug
      }
      info {
        hasLogo
        url
      }
      media {
        transform
        url
      }
    }
  }
`,
  [NARRATIVE_OWNER_FRAGMENT, VALUATION_FRAGMENT]
);
